import { CheckOutlined } from "@ant-design/icons";
import { App, Flex } from "antd";
import { FC } from "react";
import { Point } from "tm-shared/types";

import { PointInfo } from "@/domains/point";
import {
    StyledUMPointCard,
    StyledUMPointInfo,
    StyledUMSelectionBadge,
} from "@/pages/WorkPlan/UnplannedPoints/Styled";

interface PointListProps {
    points: Point[];
    selectedPoints: Point[];
    onToggleSelection: (point: Point) => void;
    pointExtraIds: string[];
}

export const PointList: FC<PointListProps> = ({
    points,
    selectedPoints,
    onToggleSelection,
    pointExtraIds,
}) => {
    const { notification } = App.useApp();

    return (
        <Flex vertical>
            {points.map((point) => {
                const isDisabled = pointExtraIds.includes(point.id);
                const isSelected = selectedPoints.some(
                    (m) => m.id === point.id,
                );

                const handleClick = () => {
                    if (isDisabled) {
                        notification.error({
                            title: `Торгова точка "${point.name}" вже в маршруті`,
                        });
                        return;
                    }
                    onToggleSelection(point);
                };

                return (
                    <StyledUMPointCard
                        key={point.id}
                        onClick={handleClick}
                        hasDuty={point.hasDebt}
                        isDisabled={isDisabled}
                        isSelected={isSelected}
                    >
                        {isSelected && (
                            <StyledUMSelectionBadge>
                                <CheckOutlined />
                            </StyledUMSelectionBadge>
                        )}
                        <StyledUMPointInfo isDisabled={isDisabled}>
                            <PointInfo point={point} />
                        </StyledUMPointInfo>
                    </StyledUMPointCard>
                );
            })}
        </Flex>
    );
};
